
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IItemAdjustment } from "@tylertech/tyler-api-types";

/**
 * ItemAdjustmentService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemAdjustmentService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetNextAdjustmentNumber(): Promise<string> {
        return this.$apiService.sendAuth("IItemAdjustmentService/GetNextAdjustmentNumber");
    }
    SaveAdjustment(pItemAdjustment: IItemAdjustment): Promise<IItemAdjustment> {
        return this.$apiService.sendAuth("IItemAdjustmentService/SaveAdjustment", pItemAdjustment);
    }
}
